module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "childnew",
    class: {
      'childnew_disabled': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "innerHTML": _vm._s(_vm.btnText)
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b255fc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/newchildbtn/ChildNewButton.vue
// module id = 878c30743fdbe6551c5b
// module chunks = 89